import axios from "axios";
import apiUrl from "./config.json";

const config = {
	headers: {
		"Access-Control-Allow-Origin": "*",
		"Content-Type": "text/plain",
	},
};

/** Base url to make requests to the movie database */
const instance = axios.create({
	baseURL: apiUrl.apiUrl,
	https: config,
	withCredentials: false,
});

export default instance;
